/**
 * @type {Object}
 * @property {array}  data  Item data
 */
const initialState = {
    shelfLives: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerShelfLife = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_SHELF_LIVES_DATA':
            var { data } = action;
            newState.shelfLives = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerShelfLife;